import type { interfaces } from '@patsnap/tahiti-core/shared/inversify';
import { CommandContribution } from '@patsnap/tahiti-core';
import { FileUploadCommandContribution } from '@/presentation/components/file-upload-zone/file-upload-command-contribution';

/**
 * 文件上传模块
 * 注册文件上传相关的服务和命令
 */
export function fileUploadModule(bind: interfaces.Bind) {
    bind(CommandContribution).to(FileUploadCommandContribution);
}
